module.exports = __webpack_public_path__ + "static/media/dropdown.834c251a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/icons/dropdown.svg
// module id = 2803
// module chunks = 118